import { HttpClient } from '@hotmart-org-ca/hot-club-http/client/http-client'

const queryClient = HttpClient.createQueryClient() // MF running in standalone mode

export default queryClient
